import React from "react";
import './App.css';
import WeatherApp from "./components/WeatherApp/WeatherApp";

function App() {
  return (
    <div className="main-container">
      <WeatherApp/>
    </div>
  );
}

export default App;
